import { ExtendedMetadata } from './components/ExtendedMetadata';
import { ProviderVariantSection } from './components/ProviderVariantSection';
import { RelatedSwimlanes } from './components/RelatedSwimlanes';
import { SequentialSeriesSection } from './components/series/SequentialSeriesSection';
import { TopicalitySeries } from './components/series/TopicalitySeries';
import { ContentStackMetadata, ProviderVariant } from './contentStack.types';

type Props = {
  sections: ContentStackMetadata['sections'];
  onSelectProvider: (variant: ProviderVariant) => void;
};
export const SectionRenderer = ({ sections, onSelectProvider }: Props) => {
  return (
    <>
      {sections.map(s => {
        if (s.type === 'sequentialSeries') {
          return (
            <SequentialSeriesSection seriesData={s.sequentialSeries} onClickVariant={onSelectProvider} key={s.id} />
          );
        }
        if (s.type === 'segmentSeries') {
          return <SequentialSeriesSection seriesData={s.segmentSeries} onClickVariant={onSelectProvider} key={s.id} />;
        }
        if (s.type === 'topicalitySeries') {
          return <TopicalitySeries seriesData={s.topicalitySeries} onClickVariant={onSelectProvider} key={s.id} />;
        }
        if (s.type === 'providerVariants') {
          if (s.providerVariants.variants.length > 1) {
            return (
              <ProviderVariantSection
                key={s.id}
                title={s.providerVariants.title}
                variants={s.providerVariants.variants}
                onSelectVariant={onSelectProvider}
              />
            );
          } else {
            return null;
          }
        }
        if (s.type === 'swimlane') {
          return <RelatedSwimlanes swimlane={s.swimlane} key={s.id} />;
        }
        if (s.type === 'extendedMetadata') {
          return <ExtendedMetadata extendedMetadata={s.extendedMetadata} key={s.id} />;
        }
        const _failIfSomeTypeIsUnhandled: never = s;
        return null;
      })}
    </>
  );
};
